const CANONICAL_ORIGIN = 'https://www.sergiopeterson.dev';

const HOME_METADATA = {
  title: 'Sergio Peterson',
  description: 'Sergio Peterson is an AI engineer on the Agent Intelligence team at Sauna by Wordware (YC S24), building agents that think, remember, and act.',
};

const BLOG_METADATA = {
  title: 'Writing | Sergio Peterson',
  description: 'Writing on software, AI, robotics, and full-stack systems.',
};

const CV_METADATA = {
  title: 'Computer Vision | Sergio Peterson',
  description: 'Computer-vision research and applied perception work by Sergio Peterson.',
  robots: 'noindex, nofollow',
};

const LAST_NUT_METADATA = {
  title: 'Last Nut',
  description: 'A private-link page.',
  robots: 'noindex, nofollow',
};

const NOT_FOUND_METADATA = {
  title: 'Page not found | Sergio Peterson',
  description: 'The requested page could not be found.',
};

function getArticleDescription(post) {
  const sourceDescription = [post.excerpt, post.description, post.summary].find(
    (value) => typeof value === 'string' && value.trim()
  );
  if (sourceDescription) return sourceDescription.trim();

  const author = Array.isArray(post.author) ? post.author.join(', ') : post.author;
  const attribution = author ? ` an article by ${author}` : ' an article';
  return `Read “${post.title},”${attribution}.`;
}

function getCanonicalUrl(pathname) {
  const path = typeof pathname === 'string' ? pathname : '/';
  const normalizedPath = `/${path.replace(/^\/+/, '')}`;
  const canonical = new URL(CANONICAL_ORIGIN);
  canonical.pathname = normalizedPath;
  return canonical.href;
}

export function getRouteMetadata(route, pathname) {
  let content = NOT_FOUND_METADATA;

  if (route.name === 'home') {
    content = HOME_METADATA;
  } else if (route.name === 'blog-index') {
    content = BLOG_METADATA;
  } else if (route.name === 'cv') {
    content = CV_METADATA;
  } else if (route.name === 'last-nut') {
    content = LAST_NUT_METADATA;
  } else if (route.name === 'blog-article') {
    content = {
      title: `${route.post.title} | Sergio Peterson`,
      description: getArticleDescription(route.post),
    };
  }

  return {
    robots: 'index, follow',
    ...content,
    url: getCanonicalUrl(pathname),
  };
}

export function applyDocumentMetadata(metadata) {
  const previousTitle = document.title;
  const attributes = [
    ['meta[name="description"]', 'content', metadata.description],
    ['meta[property="og:title"]', 'content', metadata.title],
    ['meta[property="og:description"]', 'content', metadata.description],
    ['meta[property="og:url"]', 'content', metadata.url],
    ['meta[name="twitter:title"]', 'content', metadata.title],
    ['meta[name="twitter:description"]', 'content', metadata.description],
    ['meta[name="robots"]', 'content', metadata.robots],
    ['link[rel="canonical"]', 'href', metadata.url],
  ];
  const previousAttributes = attributes.map(([selector, attribute, value]) => {
    const element = document.querySelector(selector);
    const previousValue = element?.getAttribute(attribute);
    if (element) element.setAttribute(attribute, value);
    return { element, attribute, previousValue };
  });

  document.title = metadata.title;

  return () => {
    document.title = previousTitle;
    previousAttributes.forEach(({ element, attribute, previousValue }) => {
      if (!element) return;
      if (previousValue === null) element.removeAttribute(attribute);
      else element.setAttribute(attribute, previousValue);
    });
  };
}
